import { render } from "./SuzuriHeader.vue?vue&type=template&id=6c014332&ts=true"
import script from "./SuzuriHeader.vue?vue&type=script&lang=ts"
export * from "./SuzuriHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__